module.exports = __webpack_public_path__ + "static/rosny-0aac6a1da68c33b36c6bf7c84d43884f.png";